// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1hnxc","dragIcon":"Choice_dragIcon__3lOGr","left":"Choice_left__1TyUr","input":"Choice_input__10sGZ"};